import { useMutation } from 'react-query';
import { UserAPI } from 'api/user';
import dispatchToast from 'helpers/dispatchToast';

export default function useResetPassword() {
  return useMutation(
    UserAPI.resetPassword,
    {
      onSuccess: ({ message }) => {
        dispatchToast({ message, type: 'success' });
      },
    }
  );
}
